<template>
  <element>
    <AppBar :title="task ? task.taskName : ''" />
    <v-container>
      <v-icon class="icon" size=60 color="#22EE33">mdi-check-bold</v-icon>
      <h5 class="subtitle w-100 text-center">{{ $t('processSuccess.subtitle') }}</h5>
      <p class="description text-center">{{ $t('processSuccess.description') }}</p>
      <v-row no-gutters justify="center" align="center">
        <v-col>
            <img src="../assets/success.webp" type="image/webp" width="90%">
        </v-col>
      </v-row>
    </v-container>
  </element>
</template>

<script>
import AppBar from "@/components/common/AppBar.vue"

export default {
  name: "ProcessSuccessPage",
  props: {
    pid: String,
    title: String
  },
  components: {
    AppBar
  },
  data() {
    return {
      task: null
    }
  },
  methods: {
    redirect() { 
      this.$store.commit('setCurrentProcess', null)
      this.$store.router.push({ path: '/dashboard'}) 
    }, 
  },
  created() {
    this.task = this.$store.getters.getCurrentTask
    // td 202009150553 adding setTimeout() to redirect to the dashboard after one 
    // Frontend/#134 td 202009171846 patch to unset process state, otherwise we are still in process mode even when navigating to the dashboard
    setTimeout( 
              /* Frontend/#134 @since 2020.1.2 */
              this.redirect,
              60000);
  }
}
</script>

<style scoped>
.icon {
  margin-top: 2.5rem;
  margin-bottom: 2.75rem;
}

.subtitle {
  color: #2E384D;
  font-size: 1.25rem;
  font-weight: bold;
}

.description {
  font-size: 0.875rem;
  font-weight: lighter;
  color: #2E384D;
  margin-top: 2.5rem;
}

.centered {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>